import getDisplayNameForUrl from 'common/src/modules/routing/utils/getDisplayNameForUrl';
import {NavigationEntry} from 'common/src/modules/routing/routing.types';

function formatNavigationHistory(history: NavigationEntry[]): string {
  if (history.length === 0) {
    return 'No navigation history available.';
  }

  const lines = history.map((entry, index) => {
    const date = new Date(entry.timestamp);
    const time = date.toLocaleTimeString();
    const pageLabel = _formatPageLabel(entry.url);

    return `${index + 1}. ${pageLabel} (${time})`;
  });

  const currentUrl = history[history.length - 1]?.url ?? 'unknown';
  const currentPageLabel = _formatPageLabel(currentUrl);

  return [
    `Navigation history (${history.length} entries, current page: ${currentPageLabel}):`,
    ...lines,
  ].join('\n');
}

function _formatPageLabel(url: string): string {
  const displayName = getDisplayNameForUrl(url);

  if (displayName === url) {
    return url;
  }

  return `${displayName} (${url})`;
}

export default formatNavigationHistory;
